function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MantineProvider as MantineProviderBase } from '@mantine/core';
import theme from '@/utils/mantine-theme';
import useAppStore from '@/stores/AppStore';
import { useLocation } from 'react-router';
import { WebRoutes } from '@/utils/constants';
export default function MantineProvider(param) {
    var children = param.children;
    var colorMode = useAppStore().colorMode;
    var pathname = useLocation().pathname;
    var isHome = pathname === WebRoutes.HOME;
    return /*#__PURE__*/ _jsx(MantineProviderBase, {
        forceColorScheme: colorMode === 'dark' || isHome ? 'dark' : 'light',
        theme: _object_spread({}, theme),
        children: children
    });
}
